import { render, staticRenderFns } from "./WeTable2.vue?vue&type=template&id=316a2f3c&"
import script from "./WeTable2.vue?vue&type=script&lang=js&"
export * from "./WeTable2.vue?vue&type=script&lang=js&"
import style0 from "./WeTable2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports